var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ChartFocusTime, ChartStackedBars } from "../svg-elements/module";
import { HtmlLegendDots } from "../html-elements/module";
import { flattenColumn, getMappingKey } from "../d3-services/_helpers";
import { filterWeeks, getNeededColumnsForHistoryV2 } from "../d3-services/data-with-history.functions";
import { GraphControllerV2 } from "./graph-v2";
import { breakpoints } from "../_styleguide/_breakpoints";
import * as d3 from "d3";
var TrendBarsStacked = /** @class */ (function (_super) {
    __extends(TrendBarsStacked, _super);
    function TrendBarsStacked(main, data, element, mapping, segment) {
        var _this = _super.call(this, main, data, element, mapping, segment) || this;
        _this.main = main;
        _this.data = data;
        _this.element = element;
        _this.mapping = mapping;
        _this.segment = segment;
        _this.chartBars = [];
        _this.chartLines = [];
        _this.pre();
        return _this;
    }
    ;
    TrendBarsStacked.prototype.pre = function () {
        this._addScale('x', 'linear', 'horizontal-reverse', '_index');
        this._addScale('y', 'linear', 'vertical', flattenColumn(this.firstMapping['column']));
        this._addAxis('x', 'x', 'bottom', 'yearly');
        this._addAxis('y', 'y', 'left', this.firstMapping['format']);
        this._addMargin(20, 60, 0, 0);
        this._addPadding(0, 0, 30, 0);
    };
    TrendBarsStacked.prototype.init = function () {
        _super.prototype._init.call(this);
        this.config.extra.xScaleTicks = "quarterly";
        var svgId = "svg-wrapper-" + this.mapping.slug;
        var container = document.createElement('section');
        container.style.height = window.innerWidth < breakpoints.sm ? "200px" : "300px";
        container.style.width = "100%";
        container.id = svgId;
        this.element.appendChild(container);
        _super.prototype._svg.call(this, container);
        this.chartStackedBars = new ChartStackedBars(this);
        //  this.chartLines.push(new ChartLineMiddled(this, getMappingKey(this.mapping.parameters[0][i],"column"), getMappingKey(this.mapping.parameters[0][i],"colour")));
        this.chartFocus = new ChartFocusTime(this);
        this.legend = new HtmlLegendDots(this);
        this.update(this.data, this.segment, false);
    };
    TrendBarsStacked.prototype.prepareData = function (data) {
        var _this = this;
        var neededColumns = getNeededColumnsForHistoryV2(data, this.mapping);
        var history = filterWeeks(data, neededColumns);
        history.forEach(function (week, i) {
            week['_index'] = i;
            week['colour'] = getMappingKey(_this.firstMapping, "colour");
        });
        var columnArray = this.mapping.parameters[0].map(function (m) { return (flattenColumn(m.column)); });
        this.keys = Object.keys(history[0]).filter(function (key) {
            return columnArray.indexOf(key) > -1;
        });
        this.stack = d3.stack()
            .keys(this.keys);
        return {
            "history": history.slice(1, history.length),
            "latest": data[0],
            "slice": history.slice(0, history.length).reverse(),
            "stacked": this.stack(history.reverse())
        };
    };
    TrendBarsStacked.prototype.redraw = function (data) {
        _super.prototype.redraw.call(this, data);
        this.chartStackedBars.redraw(data.stacked);
        this.chartFocus.redraw(data);
    };
    TrendBarsStacked.prototype.draw = function (data) {
        var _this = this;
        this.scales.x.set(data.slice.map(function (d) { return d[_this.parameters.x]; }));
        var minValue = 0; // d3.min(data.map(d => ((d[this.yParameter]) * .85)));
        var valueArray = [];
        for (var _i = 0, _a = data.slice; _i < _a.length; _i++) {
            var week = _a[_i];
            var v = 0;
            for (var _b = 0, _c = this.mapping.parameters[0]; _b < _c.length; _b++) {
                var map = _c[_b];
                v = v + week[flattenColumn(map.column)];
                //   valueArray = valueArray.push(data.slice.map( d => d[getMappingKey(map,"column")]))
            }
            valueArray.push(v);
        }
        this.scales.y.set(valueArray, minValue);
        this.chartStackedBars.draw(data.stacked);
        this.chartFocus.draw();
    };
    TrendBarsStacked.prototype.update = function (data, segment, update) {
        _super.prototype._update.call(this, data, segment, update);
    };
    return TrendBarsStacked;
}(GraphControllerV2));
export default TrendBarsStacked;
